import React from 'react';
import FooterImg from "../assets/images/truest-footerImg.png";
import ZenithLogo from "../assets/images/zenith-logo.svg";
import Code4renaLogo from "../assets/images/code4rena-logo.svg";

const AuditedBy = () => {
  return (
    <section className="pt-32 pb-20 bg-black">
      <div className="w-full max-w-[1180px] mx-auto">
        <p className="text-[18px] font-semibold leading-[171.4%] tracking-[-0.28px] font-sora mb-10 text-white text-center">Audited by</p>
        <div className="flex flex-wrap justify-center gap-6 items-center">
          {/* Zelliv Logo */}
          <div className="border border-white rounded-[16px]">
            <img 
              src={FooterImg}
              alt="Zelliv" 
              className="my-6 mx-[40px] w-[150px] h-[60px] object-contain" 
            />
          </div>
          
          {/* Zenith Logo */}
          <div className="border border-white rounded-[16px]">
            <img 
              src={ZenithLogo}
              alt="Zenith" 
              className="my-6 mx-[40px] w-[150px] h-[60px] object-contain" 
            />
          </div>
          
          {/* Code4rena Logo */}
          <div className="border border-white rounded-[16px]">
            <img 
              src={Code4renaLogo}
              alt="Code4rena" 
              className="my-6 mx-[40px] w-[150px] h-[60px] object-contain" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuditedBy; 